import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./Sidebar.css";

import {
  FiGrid,        // Dashboard
  FiClipboard,   // Registration
  FiHome,        // Hotel Owners
  FiCompass,     // Guide
  FiUser,        // Traveler’s
  FiDownload,    // Withdrawal
  FiRotateCcw,   // Refunds & Disputes
  FiList,        // Listings
  FiShield,      // Visa Manage & Audit
  FiDollarSign,  // Finance
  FiBriefcase,
  FiSettings,
  FiCalendar, 
  FiBarChart,     // Commission Manage
  FiMessageSquare, // Reviews
  FiLifeBuoy,      // Support & Tickets
  FiRadio,         // Broadcast
  FiActivity,      // Audit Logs
  FiTrendingUp,    // Reports & BI
  FiServer,        // System Health
  FiLogOut       // Logout
} from "react-icons/fi";


export default function Sidebar() {
  const navigate = useNavigate();
  const linkCls = ({ isActive }) => `sb-link${isActive ? " active" : ""}`;

  async function handleLogout() {
    try {
      
      localStorage.removeItem("token");
      localStorage.removeItem("adminToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
      sessionStorage.removeItem("token");

      navigate("/admin/login", { replace: true });
    } catch (e) {
      navigate("/admin/login", { replace: true });
    }
  }

  return (
    <aside className="sb">
      <div className="sb-brand">SoloWay</div>

      <nav className="sb-nav">
        <NavLink to="/admin/dashboard" className={linkCls}>
          <FiGrid className="sb-icon" />
          <span>Dashboard</span>
        </NavLink>

        <NavLink to="/admin/registration" className={linkCls}>
          <FiClipboard className="sb-icon" />
          <span>Registration</span>
        </NavLink>

        <NavLink to="/admin/hotel-owners" className={linkCls}>
          <FiHome className="sb-icon" />
          <span>Hotel Owners</span>
        </NavLink>

        <NavLink to="/admin/guides" className={linkCls}>
          <FiCompass className="sb-icon" />
          <span>Guides</span>
        </NavLink>

        <NavLink to="/admin/all-travelers" className={linkCls}>
          <FiUser className="sb-icon" />
          <span>Travelers</span>
        </NavLink>

        <NavLink to="/admin/travelers" className={linkCls}>
          <FiUser className="sb-icon" />
          <span>Traveler Agents</span>
        </NavLink>

        <NavLink to="/admin/withdrawals" className={linkCls}>
          <FiDownload className="sb-icon" />
          <span>Withdrawal</span>
        </NavLink>

        <NavLink to="/admin/refunds" className={linkCls}>
          <FiRotateCcw className="sb-icon" />
          <span>Refunds & Disputes</span>
        </NavLink>

        <NavLink to="/admin/listings" className={linkCls}>
          <FiList className="sb-icon" />
          <span>Listings</span>
        </NavLink>

        <NavLink to="/admin/reviews" className={linkCls}>
          <FiMessageSquare className="sb-icon" />
          <span>Review Moderation</span>
        </NavLink>

        <NavLink to="/admin/tickets" className={linkCls}>
          <FiLifeBuoy className="sb-icon" />
          <span>Support & Tickets</span>
        </NavLink>

        <NavLink to="/admin/broadcast" className={linkCls}>
          <FiRadio className="sb-icon" />
          <span>Broadcast Alerts</span>
        </NavLink>

        <NavLink to="/admin/audit-logs" className={linkCls}>
          <FiActivity className="sb-icon" />
          <span>Audit Logs</span>
        </NavLink>

        <NavLink to="/admin/visas" className={linkCls}>
          <FiShield className="sb-icon" />
          <span>Visa Manage</span>
        </NavLink>

        <NavLink to="/admin/events" className={linkCls}>
          <FiCalendar className="sb-icon" />
          <span>Events</span>
        </NavLink>

        <NavLink to="/admin/commissions" className={linkCls}>
          <FiBarChart className="sb-icon" />
          <span>Commissions & Limits</span>
        </NavLink>

        <NavLink to="/admin/finance" className={linkCls}>
          <FiDollarSign className="sb-icon" />
          <span>Finance</span>
        </NavLink>

        <NavLink to="/admin/solowayfinance" className={linkCls}>
          <FiBriefcase className="sb-icon" />
          <span>SoloWay Finance</span>
        </NavLink>

        <NavLink to="/admin/reports" className={linkCls}>
          <FiTrendingUp className="sb-icon" />
          <span>Reports & BI</span>
        </NavLink>

        <NavLink to="/admin/system-health" className={linkCls}>
          <FiServer className="sb-icon" />
          <span>System Health</span>
        </NavLink>

        <NavLink to="/admin/settings" className={linkCls}>
          <FiSettings className="sb-icon" />
          <span>SoloWay Settings</span>
        </NavLink>

      </nav>

      {/* Logout pinned to bottom */}
      <div className="sb-footer">
        <button className="logout-btn" onClick={handleLogout}>
          <FiLogOut className="sb-icon" />
          <span>Log out</span>
        </button>
      </div>
    </aside>
  );
}
